import { CreationToolFrame } from '../../types'

export type ArtboardRef = {
    getFrames: () => CreationToolFrame[]
}

export type ArtboardDragPosition = {
    x: number
    y: number
    rotation: number
    scaleX: number
    scaleY: number
}

export type ArtboardCropPosition = {
    x: number
    y: number
    width: number
    height: number
}

export enum ArtboardCornerPosition {
    TopLeft = 'topleft',
    TopRight = 'topright',
    BottomLeft = 'bottomleft',
    BottomRight = 'bottomright',
}

export enum ArtboardDragType {
    Move = 'move',
    Resize = 'resize',
    Rotate = 'rotate',
}

export type ArtboardDragBounds = {
    left: number
    top: number
    right: number
    bottom: number
}

export type ArtboardTextProps = {
    text: string
    color: string
    strokeColor?: string
    fontFamily: string
    fontSize: number
    fontWeight?: 'normal' | 'bold'
    lineHeight?: number
    autofit?: boolean
}

export type ArtboardBaseLayerProps = {
    defaultX: number
    defaultY: number
    defaultRotation?: number
    moveable?: boolean
    rotateable?: boolean
    resizeable?: boolean
}
